import { render, staticRenderFns } from "./GameCard.vue?vue&type=template&id=75af1dbd&scoped=true"
import script from "./GameCard.vue?vue&type=script&lang=js"
export * from "./GameCard.vue?vue&type=script&lang=js"
import style0 from "./GameCard.vue?vue&type=style&index=0&id=75af1dbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75af1dbd",
  null
  
)

export default component.exports